export const applicationTranslations = {
  lv: {
    actions: 'Pieteikuma darbības',
    title: 'Prakses pieteikumi',
    navigation: 'Pieteikumi',
    attraction: 'Piesaiste',
    description:
      'Šeit ir visi pieteikumi jūsu vakancēm — gan tie, ko vēl varat apstiprināt, gan tie, kas pēdējā mēneša laikā aizgāja citām prakses vietām.',
    search: 'Meklēt pēc izglītības iestādes, vakances…',
    filters: 'Filtri',
    all: 'Visi pieteikumi',
    pending: 'Gaida atbildi',
    missed: 'Aizņemts citur',
    clear: 'Notīrīt',
    apply: 'Filtrēt',
    empty: 'Pieteikumi nav atrasti.',
    loadError: 'Neizdevās ielādēt pieteikumus',
    error: 'Darbība neizdevās. Mēģiniet vēlreiz.',
    accept: 'Pieņemt',
    decline: 'Noraidīt',
    delete: 'Dzēst no saraksta',
    info: 'Info',
    motivation: 'Motivācija',
    cv: 'Praktikanta CV',
    cvHelp: 'CV veidojas automātiski no praktikanta profila un iepriekšējām praksēm Edy365.',
    current: 'Pašlaik',
    completed: 'Pabeigts',
    experience: 'Pieredze un prakses',
    skills: 'Prasmes',
    skillLevels: {
      Basic: 'Pamatlīmenis',
      Average: 'Vidējs',
      AboveAverage: 'Virs vidējā',
      Expert: 'Eksperts',
      NotSet: 'Nav norādīts',
    },
    notProvided: 'Nav norādīts.',
    licenseCategory: '{{category}} kategorijas tiesības',
    acceptPlacement: 'Pieņemt praksē',
    program: 'Prakses programma',
    programHelp:
      'Šo programmu izveidojusi izglītības iestāde. Praktikants pie katra dienasgrāmatas ieraksta izvēlas vienu no šiem punktiem.',
    planPoint: 'Plāna punkts',
    programHours: 'Stundas',
    total: 'Kopā',
    noProgramItems: 'Programmas punkti nav pieejami.',
    noProgram: 'Praktikantam nav prakses programmas.',
    noVacancy: 'Vakance dzēsta',
    acceptTitle: 'Pieņemt pieteikumu',
    declineTitle: 'Noraidīt pieteikumu',
    deleteTitle: 'Dzēst pieteikumu',
    acceptHelp:
      'Pieņemot pieteikumu, praktikantam tiks izveidota prakses vieta. Norādiet prakses vadītāju un līguma datus.',
    declineHelp: 'Praktikants saņems e-pastu par noraidījumu. Pieteikums tiks izņemts no saraksta.',
    deleteHelp: 'Neaktuālais pieteikums tiks izņemts no saraksta.',
    missedHelp:
      'Praktikants jau ir pieņēmis citu prakses vietu. Šādu pieteikumu vairs nevar apstiprināt. Neaktuālos pieteikumus sarakstā rāda vienu mēnesi.',
    saved: 'Pieteikums apstrādāts',
    loading: 'Ielādē…',
    supervisor: 'Prakses vadītājs',
    supervisorSearch: 'Meklēt vadītāju…',
    noSupervisors: 'Nav atrasts neviens vadītājs',
    orgName: 'Organizācijas nosaukums',
    orgRegNo: 'Reģistrācijas numurs',
    orgLegalAddress: 'Juridiskā adrese',
    address: 'Prakses vietas adrese',
    signatory: 'Paraksttiesīgā persona',
    hours: '{{count}} st.',
    ongoing: 'Šobrīd',
    ownCar: 'Savs auto',
    educationLevels: {
      Secondary: 'Vidējā izglītība',
      ProfSecondary: 'Profesionālā vidējā izglītība',
      College: 'Koledža',
      Bachelor: 'Bakalaurs',
      Masters: 'Maģistrs',
      Doctor: 'Doktors',
      ProfRandom: 'Profesionālā izglītība',
      NotSet: 'Nav norādīts',
    },
    education: 'Izglītība',
    work: 'Darba pieredze',
    computerSkills: 'Datorprasmes',
    languages: 'Valodas',
    driverLicenses: 'Autovadītāja apliecība',
    otherSkills: 'Citas prasmes',
    noCv: 'CV dati nav pieejami.',
    columns: {
      sent: 'Saņemts',
      intern: 'Students',
      eduorg: 'Izglītības iestāde',
      vacancy: 'Vakance',
      program: 'Prakses programma',
      start: 'Sākums',
      end: 'Beigas',
      cv: 'CV',
      motivation: 'Motivācija',
      status: 'Statuss',
    },
  },
  en: {
    actions: 'Application actions',
    title: 'Internship applications',
    navigation: 'Applications',
    attraction: 'Recruitment',
    description:
      'Applications to your vacancies — those awaiting your decision and those who accepted another placement in the last month.',
    search: 'Search by educational institution or vacancy…',
    filters: 'Filters',
    all: 'All applications',
    pending: 'Awaiting response',
    missed: 'Placed elsewhere',
    clear: 'Clear',
    apply: 'Apply filters',
    empty: 'No applications found.',
    loadError: 'Could not load applications',
    error: 'The action failed. Please try again.',
    accept: 'Accept',
    decline: 'Decline',
    delete: 'Remove from list',
    info: 'Info',
    motivation: 'Motivation',
    cv: 'Applicant CV',
    cvHelp:
      'The CV is generated automatically from the applicant’s profile and previous internships in Edy365.',
    current: 'Current',
    completed: 'Completed',
    experience: 'Experience and internships',
    skills: 'Skills',
    skillLevels: {
      Basic: 'Basic',
      Average: 'Average',
      AboveAverage: 'Above average',
      Expert: 'Expert',
      NotSet: 'Not specified',
    },
    notProvided: 'Not provided.',
    licenseCategory: 'Category {{category}} license',
    acceptPlacement: 'Accept for internship',
    program: 'Internship program',
    programHelp:
      'This program was created by the educational institution. The intern selects one of these points for each diary entry.',
    planPoint: 'Plan item',
    programHours: 'Hours',
    total: 'Total',
    noProgramItems: 'Program items are unavailable.',
    noProgram: 'The applicant has no internship program.',
    noVacancy: 'Vacancy deleted',
    acceptTitle: 'Accept application',
    declineTitle: 'Decline application',
    deleteTitle: 'Delete application',
    acceptHelp:
      'Accepting creates an internship placement. Select a supervisor and enter the agreement details.',
    declineHelp:
      'The applicant will receive a decline email. The application will be removed from the list.',
    deleteHelp: 'The outdated application will be removed from the list.',
    missedHelp:
      'The applicant has accepted another placement. This application can no longer be accepted. Outdated applications remain visible for one month.',
    saved: 'Application processed',
    loading: 'Loading…',
    supervisor: 'Internship supervisor',
    supervisorSearch: 'Search supervisors…',
    noSupervisors: 'No supervisors found',
    orgName: 'Organization name',
    orgRegNo: 'Registration number',
    orgLegalAddress: 'Legal address',
    address: 'Workplace address',
    signatory: 'Authorized signatory',
    hours: '{{count}} h',
    ongoing: 'Present',
    ownCar: 'Own car',
    educationLevels: {
      Secondary: 'Secondary education',
      ProfSecondary: 'Vocational secondary education',
      College: 'College',
      Bachelor: 'Bachelor',
      Masters: 'Masters',
      Doctor: 'Doctorate',
      ProfRandom: 'Vocational education',
      NotSet: 'Not specified',
    },
    education: 'Education',
    work: 'Work experience',
    computerSkills: 'Computer skills',
    languages: 'Languages',
    driverLicenses: 'Driving license',
    otherSkills: 'Other skills',
    noCv: 'CV details are unavailable.',
    columns: {
      sent: 'Received',
      intern: 'Student',
      eduorg: 'Educational institution',
      vacancy: 'Vacancy',
      program: 'Internship program',
      start: 'Start',
      end: 'End',
      cv: 'CV',
      motivation: 'Motivation',
      status: 'Status',
    },
  },
}
